/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portfolio_Project_5_ResultInputs */

const et_portfolio_project_5_result = /** @type {(inputs: Portfolio_Project_5_ResultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saavutasime alla 1s laadimisaja, paremad positsioonid ja suurema kasutajate kaasatuse.`)
};

const en_portfolio_project_5_result = /** @type {(inputs: Portfolio_Project_5_ResultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Achieved sub-1s load time, improved rankings, and increased user engagement.`)
};

/**
* | output |
* | --- |
* | "Achieved sub-1s load time, improved rankings, and increased user engagement." |
*
* @param {Portfolio_Project_5_ResultInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const portfolio_project_5_result = /** @type {((inputs?: Portfolio_Project_5_ResultInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portfolio_Project_5_ResultInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_portfolio_project_5_result(inputs)
	return en_portfolio_project_5_result(inputs)
});